import { api } from '@/services/api';
import { useToast } from '@/hooks/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { GET_SUPPLEMENTAL_ASSETS_QUERY_KEY } from './useGetSupplementalAssets';
import { GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY } from './useGetCriticalGeometryArtifacts';

export const useReprocessManifestCriticalGeometry = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ['reprocessManifestCriticalGeometry'],
    mutationFn: ({ tenantId, assetId }: { tenantId: string; assetId: string }) =>
      api.assets.putManifestCriticalGeometry(tenantId, assetId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ASSET_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [GET_SUPPLEMENTAL_ASSETS_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY], exact: false });
      showToast({ message: 'Part analysis updated', type: 'success' });
    },
    onError: () => {
      showToast({ message: 'Failed to update part analysis', type: 'error' });
    },
  });

  return {
    reprocessManifestCriticalGeometry: mutate,
    reprocessManifestCriticalGeometryAsync: mutateAsync,
    isPending,
  };
};
